import React, { useState, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { Paper, Divider, Fade, Box } from '@mui/material';
import { Virtuoso } from 'react-virtuoso';
import useAPI from '../../../../../../api';
import useTranslate from '../../../../../../Hooks/useTranslate';
import { openSnackbarAdviseAtom } from '../../../../../../Atoms';
import Header from '../../../../../../Components/ContactListWrapper/EntriesWrapper/Header';
import OverlapAccordion from './Components/OverlapAccordion';
import BackButton from '../../../BackButton';

const OverlapsPage = function OverlapsPage({
  overlapSummaries = [],
  close = () => {},
  show = false,
  reloadSummaries = () => {},
}) {
  const API = useAPI();
  const translate = useTranslate();
  const openSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const [allSections, setAllSections] = useState([]);

    useEffect(() => {
      API.getWaveSections(
        (res) => {
          setAllSections(res);
        },
        () => {
          setAllSections([]);
        }
      );
    }, []);

  const [overlaps, setOverlaps] = useState(overlapSummaries);

  useEffect(() => {
    setOverlaps(overlapSummaries);
  }, [overlapSummaries]);

  const submitResolvedOverlaps = (simulationId, resolvedOverlaps) => {
    API.resolveSimulationOverlaps(
      simulationId,
      resolvedOverlaps,
      (response) => {
        setOverlaps(response ?? []);
        openSnackbar({
          message: translate('OVERLAPS_RESOLVED_SUCCESSFULLY'),
          severity: 'success',
        });
      },
      () => {
        openSnackbar({
          message: translate('ERROR_RESOLVING_OVERLAPS'),
          severity: 'error',
        });
      }
    );
  };

  useEffect(() => {
    if (overlaps?.length === 0) {
      reloadSummaries();
      close();
    }
  }, [overlaps]);

  return (
    <Fade in={show} unmountOnExit>
      <Paper
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Header
          hideSearchBar
          hideSorting
          hideFilters
          hideExportExcel
          title={`OVERLAPS`}
          caption={<BackButton onClick={close} label={'SIMULATIONS_HISTORY'} />}
        />
        <Divider />
        <Box sx={{ flexGrow: 1, minHeight: 0, width: '100%' }}>
          <Virtuoso
            style={{ height: '100%', width: '100%' }}
            data={overlaps ?? []}
            computeItemKey={(index, summary) => summary.simulationId}
            itemContent={(index, summary) => (
              <Box
                sx={{
                  paddingX: '16px',
                  paddingTop: index === 0 ? '16px' : 0,
                  paddingBottom: '8px',
                }}
              >
                <OverlapAccordion
                  simulationId={summary.simulationId}
                  customerCount={summary.customerCount}
                  sectionCombination={summary.sectionCombination}
                  overlapDetails={summary.overlapDetails}
                  sections={allSections}
                  submitResolvedOverlaps={submitResolvedOverlaps}
                />
              </Box>
            )}
          />
        </Box>
      </Paper>
    </Fade>
  );
};

export default OverlapsPage;
